// ── NAVIGATION ────────────────────────────────────────────────────────────────
export const NAV_ITEMS = [
  { key: "dashboard", icon: "grid",     label: "Genel Bakış" },
  { key: "devices",   icon: "devices",  label: "Cihazlar",        badge: 6 },
  { key: "policies",  icon: "shield",   label: "Politikalar" },
  { key: "apps",      icon: "package",  label: "Uygulamalar" },
  { key: "users",     icon: "users",    label: "Kullanıcılar" },
  { key: "reports",   icon: "chart",    label: "Raporlar" },
  { key: "settings",  icon: "settings", label: "Ayarlar" },
  { key: "enrollment", icon: "qrcode",  label: "MDM Kaydı" },
  { key: "apps-management", icon: "package",  label: "Uygulamalar (Yön.)" },
];

// ── DEVICES ───────────────────────────────────────────────────────────────────
export const DEVICES = [
  { id:1,  name:'MacBook Pro 16"',   type:"mac",     os:"macOS 14.3",       serial:"C02XL2LMJG5H", status:"online",  compliance:"compliant", user:"ahmet.kaya",    dept:"Mühendislik", lastSeen:"2 dk",  storage:68, battery:87, encrypted:true },
  { id:2,  name:"iPhone 15 Pro",     type:"iphone",  os:"iOS 17.2",         serial:"DNPXC2ABCDEF", status:"online",  compliance:"compliant", user:"zeynep.arslan", dept:"Pazarlama",   lastSeen:"5 dk",  storage:41, battery:62, encrypted:true },
  { id:3,  name:"Surface Pro 9",     type:"windows", os:"Windows 11 23H2",  serial:"MX12345678",   status:"offline", compliance:"breach",    user:"murat.demir",   dept:"Satış",       lastSeen:"2 sa",  storage:85, battery:0,  encrypted:false },
  { id:4,  name:"MacBook Air M3",    type:"mac",     os:"macOS 14.2",       serial:"C02ZK1PLMD6T", status:"online",  compliance:"compliant", user:"selin.yilmaz",  dept:"Finans",      lastSeen:"1 dk",  storage:32, battery:45, encrypted:true },
  { id:5,  name:'iPad Pro 12.9"',    type:"ipad",    os:"iPadOS 17.3",      serial:"DMPX1234ABCD", status:"online",  compliance:"warning",   user:"emre.bora",     dept:"Tasarım",     lastSeen:"12 dk", storage:55, battery:91, encrypted:true },
  { id:6,  name:"Dell XPS 15",       type:"windows", os:"Windows 11 22H2",  serial:"DL987654321",  status:"online",  compliance:"breach",    user:"can.koc",       dept:"Operasyon",   lastSeen:"3 dk",  storage:72, battery:0,  encrypted:false },
  { id:7,  name:'MacBook Pro 14"',   type:"mac",     os:"macOS 14.3",       serial:"F4KXW8ABCDEF", status:"online",  compliance:"compliant", user:"lale.sahin",    dept:"Hukuk",       lastSeen:"8 dk",  storage:29, battery:34, encrypted:true },
  { id:8,  name:"iPhone 14",         type:"iphone",  os:"iOS 17.1",         serial:"DMQR5678WXYZ", status:"online",  compliance:"warning",   user:"burak.yildiz",  dept:"Mühendislik", lastSeen:"20 dk", storage:60, battery:78, encrypted:true },
  { id:9,  name:"HP EliteBook 840",  type:"windows", os:"Windows 11 23H2",  serial:"HP987XYZ1234", status:"online",  compliance:"compliant", user:"naz.celik",     dept:"İK",          lastSeen:"4 dk",  storage:45, battery:0,  encrypted:true },
  { id:10, name:"iPad Air",          type:"ipad",    os:"iPadOS 17.2",      serial:"DPQR5555ABCD", status:"offline", compliance:"warning",   user:"caner.ozkan",   dept:"Satış",       lastSeen:"1 gün", storage:38, battery:0,  encrypted:false },
];

// ── ACTIVITIES ────────────────────────────────────────────────────────────────
export const ACTIVITIES = [
  { id:1, msg:"iPhone 15 Pro sisteme kaydedildi",          detail:"zeynep.arslan · Pazarlama",           time:"5 dk",   icon:"check",   color:"#22c55e" },
  { id:2, msg:"Surface Pro güvenlik ihlali tespit edildi",  detail:"murat.demir · Disk şifreleme kapalı", time:"2 sa",   icon:"alert",   color:"#ef4444" },
  { id:3, msg:"Uzaktan silme komutu gönderildi",            detail:"admin · Dell XPS 15",                 time:"3 sa",   icon:"refresh", color:"#f59e0b" },
  { id:4, msg:"macOS 14.3 güncellemesi dağıtıldı",          detail:"system · 89 cihaz etkilendi",         time:"5 sa",   icon:"zap",     color:"#3b82f6" },
  { id:5, msg:"Yeni güvenlik politikası atandı",            detail:"admin · Mühendislik grubu",           time:"1 gün",  icon:"shield",  color:"#a78bfa" },
  { id:6, msg:"iPad Pro cihaz kaydı tamamlandı",            detail:"emre.bora · Tasarım",                 time:"1 gün",  icon:"check",   color:"#22c55e" },
];

// ── ALERTS ────────────────────────────────────────────────────────────────────
export const ALERTS = [
  { id:1, msg:"3 cihazda disk şifreleme devre dışı",      severity:"critical", count:3 },
  { id:2, msg:"12 cihazda bekleyen güvenlik güncellemesi", severity:"warning",  count:12 },
  { id:3, msg:"5 cihaz 48 saattir çevrimdışı",            severity:"warning",  count:5 },
  { id:4, msg:"Politika dışı uygulama tespit edildi",      severity:"info",     count:1 },
];

// ── APPS ───────────────────────────────────────────────────────────────────────
export const APPS = [
  {
    id: 1,
    name: "Slack",
    vendor: "Slack Technologies",
    version: "4.39.90",
    platform: "macOS + Windows",
    status: "deployed",
    devices: 142,
    pending: 6,
  },
  {
    id: 2,
    name: "Zoom",
    vendor: "Zoom Video Communications",
    version: "5.17.3",
    platform: "Tümü",
    status: "deployed",
    devices: 187,
    pending: 12,
  },
  {
    id: 3,
    name: "Xcode",
    vendor: "Apple",
    version: "15.2",
    platform: "macOS",
    status: "partial",
    devices: 34,
    pending: 5,
  },
  {
    id: 4,
    name: "Office 365",
    vendor: "Microsoft",
    version: "2401",
    platform: "macOS + Windows",
    status: "deployed",
    devices: 162,
    pending: 0,
  },
  {
    id: 5,
    name: "Figma",
    vendor: "Figma Inc.",
    version: "Latest",
    platform: "Tümü",
    status: "planned",
    devices: 0,
    pending: 48,
  },
];

// ── USERS ──────────────────────────────────────────────────────────────────────
export const USERS = [
  { id: 1, name: "Ahmet Kaya",       email: "ahmet.kaya@example.com",       role: "Süper Admin", dept: "Mühendislik", devices: 5,  lastActive: "5 dk" },
  { id: 2, name: "Zeynep Arslan",    email: "zeynep.arslan@example.com",    role: "Yönetici",    dept: "Pazarlama",   devices: 3,  lastActive: "15 dk" },
  { id: 3, name: "Murat Demir",      email: "murat.demir@example.com",      role: "Editör",      dept: "Satış",       devices: 4,  lastActive: "1 sa" },
  { id: 4, name: "Selin Yılmaz",     email: "selin.yilmaz@example.com",     role: "Okuyucu",     dept: "Finans",      devices: 2,  lastActive: "3 sa" },
  { id: 5, name: "Naz Çelik",        email: "naz.celik@example.com",        role: "Yönetici",    dept: "İK",          devices: 3,  lastActive: "1 gün" },
  { id: 6, name: "Can Koç",          email: "can.koc@example.com",          role: "Editör",      dept: "Operasyon",   devices: 4,  lastActive: "2 gün" },
  { id: 7, name: "Lale Şahin",       email: "lale.sahin@example.com",       role: "Okuyucu",     dept: "Hukuk",       devices: 2,  lastActive: "3 gün" },
  { id: 8, name: "Burak Yıldız",     email: "burak.yildiz@example.com",     role: "Müdahale",    dept: "Mühendislik", devices: 6,  lastActive: "10 dk" },
  { id: 9, name: "Emre Bora",        email: "emre.bora@example.com",        role: "Editör",      dept: "Tasarım",     devices: 3,  lastActive: "4 sa" },
  { id: 10,name: "Caner Özkan",      email: "caner.ozkan@example.com",      role: "Okuyucu",     dept: "Satış",       devices: 1,  lastActive: "5 gün" },
];

// ── POLICIES & GROUPS ─────────────────────────────────────────────────────────
export const GROUPS = [
  { id: 1, name: "Mühendislik",        devices: 64 },
  { id: 2, name: "Satış",              devices: 32 },
  { id: 3, name: "Pazarlama",          devices: 18 },
  { id: 4, name: "Finans",             devices: 21 },
  { id: 5, name: "Genel Kullanıcılar", devices: 112 },
];

export const POLICIES = [
  {
    id: 1,
    name: "Tam Disk Şifreleme",
    type: "Güvenlik",
    platform: "macOS + Windows",
    status: "active",
    targets: [1, 2, 5],
    updatedAt: "2 gün önce",
  },
  {
    id: 2,
    name: "Kritik Güncellemeler (24s)",
    type: "Güncelleme",
    platform: "Tümü",
    status: "active",
    targets: [1, 3, 4, 5],
    updatedAt: "5 saat önce",
  },
  {
    id: 3,
    name: "Misafir Wi‑Fi Profili",
    type: "Ağ",
    platform: "iOS/iPadOS",
    status: "draft",
    targets: [3],
    updatedAt: "1 hafta önce",
  },
  {
    id: 4,
    name: "USB Depolama Engelleme",
    type: "Güvenlik",
    platform: "Windows",
    status: "active",
    targets: [2, 5],
    updatedAt: "3 gün önce",
  },
];

// ── CHART DATA ────────────────────────────────────────────────────────────────
export const ENROLL_DATA = [
  { day:"Pzt", kayıt:4, çıkış:1 },
  { day:"Sal", kayıt:7, çıkış:2 },
  { day:"Çar", kayıt:3, çıkış:0 },
  { day:"Per", kayıt:9, çıkış:3 },
  { day:"Cum", kayıt:6, çıkış:1 },
  { day:"Cmt", kayıt:2, çıkış:0 },
  { day:"Paz", kayıt:1, çıkış:0 },
];

export const COMPLIANCE_DATA = [
  { h:"H1", uyumlu:210, uyarı:18, ihlal:8 },
  { h:"H2", uyumlu:218, uyarı:15, ihlal:6 },
  { h:"H3", uyumlu:225, uyarı:12, ihlal:9 },
  { h:"H4", uyumlu:231, uyarı:10, ihlal:6 },
];

export const PIE_DATA = [
  { name:"macOS",      value:89, color:"#3b82f6" },
  { name:"iOS/iPadOS", value:74, color:"#a78bfa" },
  { name:"Windows",    value:84, color:"#22d3ee" },
];

// ── CONSTANTS ─────────────────────────────────────────────────────────────────
export const COMPLIANCE_MAP = {
  compliant: ["#22c55e", "Uyumlu"],
  warning:   ["#f59e0b", "Uyarı"],
  breach:    ["#ef4444", "İhlal"],
};

export const DEVICE_ICON  = { mac:"laptop", iphone:"phone", ipad:"monitor", windows:"monitor" };
export const DEVICE_COLOR = { mac:"#3b82f6", iphone:"#a78bfa", ipad:"#22d3ee", windows:"#6366f1" };
